
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/amateur-programs",
      function () {
        return require("private-next-pages/amateur-programs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/amateur-programs"])
      });
    }
  